import { Component, Input, OnInit, input } from '@angular/core';
import {
  FormBuilder,
  FormControlName,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ApiServiceService } from '../../services/api-service.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LoaderService } from '../../services/loader.service';
import { AuthService } from '../../services/auth.service';
import { stringify } from 'querystring';
import { response } from 'express';

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss'],
})
export class SigninComponent implements OnInit {
  public registerForm!: FormGroup;
  public LoginForm!: FormGroup;
  isLogin: boolean = false;
  isloginValue = 1;

  showOtpInputBoxes = false; // Controls visibility of OTP input boxes
  otpres: any;
  mobileres: any;
  isMobileVerified = false; // Tracks if the mobile number is verified

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private api: ApiServiceService,
    private router: Router,
    private Loader: LoaderService,
    private route: ActivatedRoute,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.initializeForms();
    this.route.params.subscribe((data: any) => {
      this.isloginValue = data['id'];
      if (this.isloginValue == 0) {
        this.isLogin = true;
      } else {
        this.isLogin = false;
      }
    });
  }

  initializeForms() {
    this.registerForm = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(3)]],
      mobile: [
        '',
        [
          Validators.required,
          Validators.minLength(10),
          Validators.maxLength(10),
          Validators.pattern(/^\d{10}$/),
        ],
      ],
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      password_confirmation: [
        '',
        [Validators.required, Validators.minLength(6)],
      ],
      accept: [false, Validators.requiredTrue],
    });

    this.LoginForm = this.fb.group({
      email_mobile: ['', Validators.required],
      password: ['', [Validators.required]],
      terms: [false, Validators.requiredTrue],
    });
  }

  hasError(controlName: string, errorName: string) {
    return this.registerForm.controls[controlName].hasError(errorName);
  }

  showOtpComponent = false; // Controls visibility of the OTP component
  otpValue: string = ''; // Stores the entered OTP value
  config = {
    length: 6, // Number of OTP digits
    allowNumbersOnly: true, // Restrict input to numbers only
    inputStyles: {
      width: '40px',
      height: '40px',
      border: '1px solid #8c05e6',
      borderRadius: '8px',
      textAlign: 'center',
      fontSize: '18px',
    },
  };

  // sendWhatsappOtp(mobile: string) {
  //   if (!this.registerForm.get('mobile')?.valid) {
  //     this.toastr.error('Please enter a valid mobile number', '', {
  //       toastClass: 'ngx-toastr toast-custom',
  //     });
  //     return;
  //   }


  //   this.api.sendWhatsappOtp(mobile).subscribe({
  //     next: (response: any) => {
  //       this.otpres = response.data.verificationCode;
  //       this.mobileres = response.data.contacts.input;
  //       this.toastr.success('OTP sent via WhatsApp', '', {
  //         toastClass: 'ngx-toastr toast-custom',
  //       });
  //       this.showOtpComponent = true; // Show OTP input boxes
  //     },
  //     error: (err) => {
  //       this.toastr.error('Failed to send OTP via WhatsApp', '', {
  //         toastClass: 'ngx-toastr toast-custom',
  //       });
  //     },
      
  //   });
    
  // }
  sendWhatsappOtp(mobile: string) {
  if (!this.registerForm.get('mobile')?.valid) {
    this.toastr.error('Please enter a valid mobile number', '', {
      toastClass: 'ngx-toastr toast-custom',
    });
    return;
  }

  // Step 1️⃣ - Check if mobile already exists in DB
  this.api.checkMobileExists(mobile).subscribe({
    next: (res: any) => {
      if (res.exists) {
        // Step 2️⃣ - If exists, show error and stop
        this.toastr.error('This mobile number is already registered', '', {
          toastClass: 'ngx-toastr toast-custom',
        });
        return;
      }

      // Step 3️⃣ - If not exist, send WhatsApp OTP
      this.api.sendWhatsappOtp(mobile).subscribe({
        next: (response: any) => {
          this.otpres = response.data.verificationCode;
          this.mobileres = response.data.contacts.input;
          this.toastr.success('OTP sent via WhatsApp', '', {
            toastClass: 'ngx-toastr toast-custom',
          });
          this.showOtpComponent = true; // Show OTP input boxes
        },
        error: () => {
          this.toastr.error('Failed to send OTP via WhatsApp', '', {
            toastClass: 'ngx-toastr toast-custom',
          });
        },
      });
    },
    error: () => {
      this.toastr.error('Something went wrong while checking mobile number', '', {
        toastClass: 'ngx-toastr toast-custom',
      });
    },
  });
}




  verifyOtp() {
    const otp = this.otpres;
    const mobile = this.registerForm.value.mobile;

    // Validate OTP
    if (!otp || otp.length !== 6) {
      this.toastr.error('Please enter a valid 6-digit OTP', '', {
        toastClass: 'ngx-toastr toast-custom',
      });
      return;
    }

    // Show loader while verifying OTP
    this.Loader.showLoader();

    // Call the API to verify the OTP
    this.api.verifyWhatsappOtp(mobile, otp).subscribe({
      next: (response) => {
        this.Loader.hideLoader();
        if (response) {
          this.toastr.success('OTP verified successfully', '', {
            toastClass: 'ngx-toastr toast-custom',
          });
          // Mark mobile as verified
          this.isMobileVerified = true;
          this.showOtpComponent = false; // Show OTP input boxes
        } else {
          this.toastr.error('Invalid OTP', '', {
            toastClass: 'ngx-toastr toast-custom',
          });
        }
      },
      error: (err) => {
        this.Loader.hideLoader();
        this.toastr.error(
          err?.error?.message || 'Verification failed. Please try again.',
          '',
          {
            toastClass: 'ngx-toastr toast-custom',
          }
        );
      },
    });
  }

  onRegister() {
    if (this.registerForm.invalid) {
      Object.keys(this.registerForm.controls).forEach((control) => {
        if (this.registerForm.controls[control].invalid) {
        }
      });
      return;
    }

    // Ensure mobile is verified before proceeding
    if (!this.isMobileVerified) {
      this.toastr.error('Please verify your mobile number first', '', {
        toastClass: 'ngx-toastr toast-custom',
      });
      return;
    }

    this.Loader.showLoader();
    this.api.register(this.registerForm.value).subscribe({
      next: (response: any) => {
        if (response.success) {
          this.Loader.hideLoader();
          this.toastr.success(response.message, '', {
            toastClass: 'ngx-toastr toast-custom',
          });
          this.isLogin = true;
        } else {
          this.toastr.error(response.message, '', {
            toastClass: 'ngx-toastr toast-custom',
          });
          alert('not complete')
        }
      },
    });
  }

  onLogin() {
    if (this.LoginForm.value.terms === false) {
      this.toastr.error('Please accept trems & conditions', '', {
        toastClass: 'ngx-toastr toast-custom',
      });
    }
    if (this.LoginForm.invalid) {
      Object.keys(this.LoginForm.controls).forEach((control) => {
        if (this.LoginForm.controls[control].invalid) {
        }
      });
      return;
    }

    this.Loader.showLoader();
    this.api.login(this.LoginForm.value).subscribe({
      next: (response: any) => {
        if (response?.success) {
          this.toastr.success('You are logged in successfully', '', {
            toastClass: 'ngx-toastr toast-custom',
          });
          this.Loader.hideLoader();
          localStorage.setItem('token', response?.access_token),
            localStorage.setItem('userId', JSON.stringify(response.user.id));
          this.authService.setUser(response.user, response.access_token);
          this.router.navigate(['']);
        } else {
          this.toastr.error(response.message, '', {
            toastClass: 'ngx-toastr toast-custom',
          });
          this.Loader.hideLoader();
        }
      },
      error: (err) => {
        this.toastr.error('Login failed');
        console.error(err);
        this.Loader.hideLoader();
      },
    });
  }

  openLogin() {
    this.isLogin = true;
  }
  openSignup() {
    this.isLogin = false;
  }
  forgetPassword(){
    this.router.navigate(['forget-Password']);
  }
}
